import { TokenResponse } from 'auth/types/token-response.type';
import { logger } from '@sanlam-glacier/app-common/modules/logger';

export const getGatewayGrantToken = async (
  tokenEndpoint: string,
  clientId: string,
  redirectUri: string,
  scopes: string[] | undefined,
  realm: string
): Promise<TokenResponse | undefined> => {
  const scopeParam = scopes ? scopes.join(',') : '';
  const params = encodeURI(
    `grant_type=ibm_security&client_id=${clientId}&redirect_uri=${redirectUri}&scope=${scopeParam}&realm=${realm}`
  );
  const tokenCreationTime = new Date();

  const result = await fetch(tokenEndpoint, {
    method: 'POST',
    credentials: 'include',
    headers: { 'Content-type': 'application/x-www-form-urlencoded', Accept: 'application/json' },
    body: params
  });

  if (result.status != 200) {
    logger.error({ message: 'Failed to fetch token.', object: { result, parameters: params } });
    return;
  }

  const jsonResult = await result.json();

  if (!jsonResult) return;

  const token = jsonResult as TokenResponse;

  if (!token.access_token || !token.expires_in) return;

  const tokenExpiryTime = tokenCreationTime;
  tokenExpiryTime.setSeconds(tokenCreationTime.getSeconds() + token.expires_in);
  token.token_expiry_time = tokenExpiryTime;

  return token;
};
